import React from 'react'
import styled from 'styled-components'
import { FiInstagram, FiMail } from 'react-icons/fi'
import { GrFacebook } from 'react-icons/gr'

function MagicCarpetFooter(props) {
  return (
    <Container>
      <Hr />
      <Grid>
        <Col1>
          <P>For Customers</P>
          <A href="https://www.bookfocal.com/how-it-works" rel="noopener" target="_blank">
            How it Works
          </A>
          <A href="https://www.bookfocal.com/trust-and-safety" rel="noopener" target="_blank">
            Trust & Safety
          </A>
          <A href="https://www.bookfocal.com/customer-faq" rel="noopener" target="_blank">
            FAQ
          </A>
          <A href="https://www.bookfocal.com/policies" rel="noopener" target="_blank">
            Policies
          </A>
          <A href="https://www.bookfocal.com/customer-terms-of-service" rel="noopener" target="_blank">
            Terms of Service
          </A>
        </Col1>
        <Col1>
          <P>For Photographers</P>
          <A href="https://www.bookfocal.com/join" rel="noopener" target="_blank">
            Join Focal
          </A>
          <A href="https://app.bookfocal.com/auth/login">Login</A>
          <A href="https://www.bookfocal.com/pricing" rel="noopener" target="_blank">
            Pricing
          </A>
          <A href="https://www.bookfocal.com/photographer-faq" rel="noopener" target="_blank">
            FAQ
          </A>
          <A href="https://www.bookfocal.com/policies" rel="noopener" target="_blank">
            Policies
          </A>
          <A href="https://www.bookfocal.com/terms-of-service" rel="noopener" target="_blank">
            Terms of Service
          </A>
        </Col1>
        <Col1>
          <P>Wedding Photographers in Other Cities</P>
          <A
            href="https://marketplace.bookfocal.com/explore/wedding-and-engagement/toronto-canada/43.6532/-79.3832"
            rel="noopener"
            target="_blank"
          >
            Toronto, Canada
          </A>
          <A
            href="https://marketplace.bookfocal.com/explore/wedding-and-engagement/edmonton-canada/53.5461/-113.4937"
            rel="noopener"
            target="_blank"
          >
            Edmonton, Canada
          </A>
          <A
            href="https://marketplace.bookfocal.com/explore/wedding-and-engagement/vancouver-canada/49.2827/-123.1207"
            rel="noopener"
            target="_blank"
          >
            Vancouver, Canada
          </A>
          <A
            href="https://marketplace.bookfocal.com/explore/wedding-and-engagement/los-angeles-usa/34.0549/-118.2426"
            rel="noopener"
            target="_blank"
          >
            Los Angeles, United States
          </A>
          <A
            href="https://marketplace.bookfocal.com/explore/wedding-and-engagement/san-diego-usa/32.715700/-117.161100"
            rel="noopener"
            target="_blank"
          >
            San Diego, United States
          </A>
          <A
            href="https://marketplace.bookfocal.com/explore/wedding-and-engagement/atlanta-usa/33.7488/-84.3877"
            rel="noopener"
            target="_blank"
          >
            Atlanta, United States
          </A>
          <A
            href="https://marketplace.bookfocal.com/explore/wedding-and-engagement/london-uk/51.5072/-0.1276"
            rel="noopener"
            target="_blank"
          >
            London, United Kingdom
          </A>
        </Col1>
      </Grid>
      <Row>
        <Row1>
          <A1 aria-label="focal pinterest" href="https://www.pinterest.ca/bookfocal/"></A1>
          <A1
            aria-label="focal facebook"
            href="https://facebook.com/bookfocal"
            rel="noopener"
            target="_blank"
          >
            <Facebook />
          </A1>
          <A1
            aria-label="focal instagram"
            href="https://instagram.com/bookfocal"
            rel="noopener"
            target="_blank"
          >
            <Instagram />
          </A1>
          <A1 aria-label="focal contact" href="mailto:contact@bookfocal.com" rel="noopener" target="_blank">
            <MailIcon />
          </A1>
        </Row1>
        <Row3>
          <A2 href="https://www.bookfocal.com/about" rel="noopener" target="_blank">
            About
          </A2>

          <A2 href="https://www.bookfocal.com/blog" rel="noopener" target="_blank">
            Blog
          </A2>

          <A2 href="https://www.bookfocal.com/focal-university" rel="noopener" target="_blank">
            Focal University
          </A2>

          <A2 href="https://www.bookfocal.com/contact" rel="noopener" target="_blank">
            Contact
          </A2>

          <A2 href="/">+1 833 253 6225</A2>
        </Row3>
        <Row1>
          <Logo>
            CopyRight © {new Date().getFullYear()}{' '}
            <Link1 href="https://www.creative-tim.com?ref=adpr-auth-footer" target="_blank">
              Focal Inc
            </Link1>
          </Logo>
        </Row1>
      </Row>
    </Container>
  )
}

export default MagicCarpetFooter

const Container = styled.div`
  position: relative;
  width: 100%;
  background: var(--dark-grey-1);
  z-index: 99;
  overflow: hidden;
  width: 100%;
  padding: 3em 7em;
  transition: height 0.3s ease-in-out;
  @media (max-width: 650px) {
    padding: 3em;
  }
  @media (max-width: 500px) {
    padding: 3em 2em;
  }
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: 4vw;
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
  }
`
const Hr = styled.hr`
  border-top: 1px solid rgb(221, 221, 221) !important;
  margin: 2em 0;
  display: block;
`

const P = styled.h1`
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  color: #fff;
  margin: 0 0 20px 0;
`

const Col1 = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  padding: 20px 0;
  height: auto;
`


const A = styled.a`
  font-weight: 400;
  word-break: break-word;
  line-height: 1.5;
  color: #fff;
  margin: 0 0 20px 0;
  font-size: 14px;
  &:hover {
    color: var(--forward);
  }
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2em 0 0 0;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`

const Row1 = styled.div`
  display: flex;
  margin: 0 0 16px 0;
`

const Row3 = styled.div`
  display: flex;
  color: #fff;
  margin: 0 0 16px 0;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`

const A1 = styled.a`
  color: #fff;
  &:hover {
    color: var(--forward);
  }
`

const A2 = styled(A)`
  font-size: 12px;
  margin: 0 8px;
  @media (max-width: 600px) {
    margin: 0 0 8px 0;
  }
`

const Facebook = styled(GrFacebook)`
  margin: 0 15px 0 0;
  color: #fff;
  font-size: 20px;
  &:hover {
    color: var(--forward);
  }
`

const Instagram = styled(FiInstagram)`
  color: #fff;
  margin: 0 15px 0 0;
  font-size: 20px;
  &:hover {
    color: var(--forward);
  }
`
const MailIcon = styled(FiMail)`
  color: #fff;
  margin: 0 15px 0 0;
  font-size: 20px;
  &:hover {
    color: var(--forward);
  }
`

const Logo = styled.div`
  color: #fff;
  font-size: 12px;
  text-align: center;
  @media (min-width: 1200px) {
    text-align: left;
  }
`

const Link1 = styled.a`
  margin: 0 0 0 5px;
  color: var(--forward);
  text-decoration: none;
  background-color: initial;
  font-weight: 500;
`
